import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import LoadThemeComponent from '../../../base/LoadThemeComponent';
import { RootState } from '../redux/store';

function SelectableLotteryDrawDatesModule() {
    const { t } = useTranslation();
    const { selectableDrawDateTimes } = useSelector((state: RootState) => state.playStore);

    if (!selectableDrawDateTimes?.length) {
        return null;
    }

    const baseView = () => (
        <div className="d-md-flex justify-content-sm-end justify-content-center draw-dates-select-wrapper">
            <p className="align-self-center text-nowrap mr-3">{t('playPicker.chooseStartingDraw')}</p>
            <select className="form-control col-12 col-sm text-nowrap" name="selectableDrawDateTime">
                <option value="" defaultValue="">
                    {t('playPicker.nearestDraw')}
                </option>
                {selectableDrawDateTimes.map((draw) => (
                    <option key={draw.dateTimeString} value={draw.dateTimeString}>
                        {draw.draw_name ? `${draw.draw_name} - ` : ''}
                        {draw.dateTimeToDisplay}
                    </option>
                ))}
            </select>
        </div>
    );
    const defaultView = () => (
        <div className="card options-card d-md-flex h-100">
            <div className="card-header">{t('playPicker.chooseStartingDraw')}</div>
            <div className="card-body">
                <select id="selectable-draw-dates" className="form-control" name="selectableDrawDateTime">
                    <option value="" defaultValue="">
                        {t('playPicker.nearestDraw')}
                    </option>
                    {selectableDrawDateTimes.map((draw) => (
                        <option key={draw.dateTimeString} value={draw.dateTimeString}>
                            {draw.draw_name ? `${draw.draw_name} - ` : ''}
                            {draw.dateTimeToDisplay}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );

    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}

export default SelectableLotteryDrawDatesModule;
